import Attendance from '../js/attendance.js';
import moment from 'moment';

var preferences = {
  PREF_API_KEY: 'frekr:apikey',
  PREF_USER: 'frekr:user',
  PREF_TAGS: 'frekr:tags',
  PREF_COMPANY: 'frekr:company',
  PREF_ATTENDANCES: 'frekr:attendances',
  PREF_ATTENDANCES_FETCH_DATE: 'frekr:attendances:fetch_date',
  PREF_GEOLOCATION: 'frekr:geolocation',
  PREF_ALLOW_BROWSER: 'frekr:allow_browser',

  // init function
  init() {
    window.console.info('Welcome to developer console. If you wish to use the app in browser mode, call `localStorage.setItem("'+
      preferences.PREF_ALLOW_BROWSER+'", true)\' and reload the page');
  },

  // SETTERS/GETTERS for actual preferences

  isInitialized: function() {
    return null !== localStorage.getItem(preferences.PREF_API_KEY);
  },
  getApiKey: function() {
    return localStorage.getItem(preferences.PREF_API_KEY);
  },
  setApiKey: function(key) {
    localStorage.setItem(preferences.PREF_API_KEY, key);
  },

  getUser: function()     { return preferences.getPropObject(preferences.PREF_USER); },
  getTags: function()     { return preferences.getPropObject(preferences.PREF_TAGS); },
  getCompany: function()  { return preferences.getPropObject(preferences.PREF_COMPANY); },
  getGeolocationEnabled: function() { return preferences.getProp(preferences.PREF_GEOLOCATION, true); },
  getAttendances: function() {
    var ret = preferences.getProp(preferences.PREF_ATTENDANCES);
    return (ret === null) ? [] : Attendance.processArray(ret);
  },
  getAttendanesFetchedAt: function() { return preferences.getPropDate(preferences.PREF_ATTENDANCES_FETCH_DATE); },

  setTags: function(tags) { preferences.setPropObject(preferences.PREF_TAGS, tags); },
  setUser: function(e)    { preferences.setPropObject(preferences.PREF_USER, e); },
  setCompany: function(c) { preferences.setPropObject(preferences.PREF_COMPANY, c); },
  setGeolocationEnabled: function(enabled) { return preferences.setProp(preferences.PREF_GEOLOCATION, enabled); },
  setAttendances: function(val) {
    if (val !== null) {
      var arr = [];
      for (const attendance of val) arr.push(attendance.getData());
      val = arr;
    }
    preferences.setProp(preferences.PREF_ATTENDANCES, val);
  },
  setAttendancesFetchedAt: function(val) { return preferences.setPropDate(preferences.PREF_ATTENDANCES_FETCH_DATE, val); },

  clear: function() {
    Object.keys(preferences).filter(key => key.indexOf('PREF_') === 0)
      .forEach(key => localStorage.removeItem(preferences[key]));
  },

  // GETTER/SETTER HELPERS

  setPropObject: function(prop, val) {
    if (val !== null) val = JSON.stringify(val);
    localStorage.setItem(prop, val);
  },
  getPropObject: function(prop) {
    var ret = localStorage.getItem(prop);
    return (ret === null) ? null : JSON.parse(ret);
  },

  setProp: function(prop, val) {
    localStorage.setItem(prop, JSON.stringify({val: val}));
  },
  getProp: function(prop, defaultRet) {
    if (typeof defaultRet === 'undefined') defaultRet = null;
    var ret = localStorage.getItem(prop);
    return (ret === null) ? defaultRet : JSON.parse(ret).val;
  },

  setPropDate: function(prop, val) {
    if (val !== null) val = val.toISOString();
    preferences.setProp(prop, val);
  },
  getPropDate: function(prop, val, defaultRet) {
    if (typeof defaultRet === 'undefined') defaultRet = null;
    var ret = localStorage.getItem(prop);
    return (ret === null) ? defaultRet : moment(JSON.parse(ret).val);
  },


  // PSEUDO-PREFERENCE FUNCTIONS (like browser detection, ...)

  isInstalledPWA() {
    if (preferences.getPropObject(preferences.PREF_ALLOW_BROWSER)) return true;
    if ('standalone' in window.navigator) return window.navigator.standalone;
    return window.matchMedia('(display-mode: standalone)').matches;
  },

  BROWSER_FF: 'ff',
  BROWSER_CHROME: 'chrome',
  BROWSER_UNKNOWN: 'browser_unknown',
  PLATFORM_ANDROID: 'android',
  PLATFORM_DESKTOP: 'desktop',
  PLATFORM_IOS: 'ios',
  PLATFORM_UNKNOWN: 'platform_unknown',

  getBrowser() {
    if (preferences.getPlatform() === preferences.PLATFORM_IOS) return preferences.BROWSER_UNKNOWN;
    var agent = window.navigator.userAgent;
    if (agent.match(/Firefox/) !== null) return preferences.BROWSER_FF;
    else if (agent.match(/Chrome/) !== null) return preferences.BROWSER_CHROME;
    else return preferences.BROWSER_UNKNOWN;
  },

  getPlatform() {
    var agent = window.navigator.userAgent;
    if (agent.match(/Android/) !== null) return preferences.PLATFORM_ANDROID;
    else if (agent.match(/(iPhone|iPad|iPod)/) !== null ||
      (agent.indexOf('Macintosh') !== -1 && window.navigator.maxTouchPoints > 1)) return preferences.PLATFORM_IOS;
    else if (agent.match(/(Linux|Windows|Macintosh)/) !== null) return preferences.PLATFORM_DESKTOP;
    else return preferences.PLATFORM_UNKNOWN;
  },
};

export default preferences;
